import ErrorBox from "components/blocks/error/ErrorBox";

interface Props {
  message?: string;
  buttonLabel?: string;
  onReturn?: () => void;
}

export default function NoAvailable(props: Props) {
  const onReturn = () => {
    // if ([1, 2, 3].includes(auth.user.startPage)) {
    //   GoPageNav(navigate, dispatch, getStartPageUrl(auth.user.startPage), {
    //     replace: true,
    //   });
    // } else {
    //   GoPageNav(navigate, dispatch, getStartPageUrl(1), {
    //     replace: true,
    //   });
    // }
    if (props.onReturn) {
      props.onReturn();
    } else {
      window.location.href = "/login";
    }
  };
  return (
    <ErrorBox
      onReturn={onReturn}
      message={props.message || "This data is no longer available"}
      buttonLabel={props.buttonLabel || "Return to myDW"}
    >
      <p>
        The page you are looking for may have been moved, deleted, or does not
        exist.
        <br />
        <br />
        Click the button below to return to a working page on the site and
        resuming using myDW.
      </p>
    </ErrorBox>
  );
}
